import script from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=6b7a05a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7a05a8"]])

export default __exports__